import { CoreGlobalFooter } from '@care/navigation';
import { Grid, Box, Typography } from '@mui/material';
import { IconIllustrationSmallCalculator } from '@care/react-icons';
import { useEffect } from 'react';
import SeoGlobalNavbar from '@/components/SeoGlobalNavbar';
import { ScreenTemplate } from '@/constants';
import {
  setPagePropertiesFromData,
  setDeviceDataFromHeaders,
  trackAmplitudeEvent,
  AmplitudeEvent,
} from '@/lib/analyticsHelper';
import SlimSearch from './CostGuideSlimSearch';

export type CostGuide404Props = {
  seoSegmentId: string;
  deviceChar: {
    device_os: string;
    is_mobile: any;
    mobile_browser_version: any;
    mobile_browser: string;
  };
};

export default function CostGuide404({ seoSegmentId, deviceChar }: CostGuide404Props) {
  const segmentInfo = seoSegmentId.split('/');
  const segmentation = segmentInfo[2];
  const city = segmentInfo[3].replace(/-/g, ' ').slice(0, -3);
  const stateCode = segmentInfo[3].replace(/-/g, ' ').slice(-2);

  useEffect(() => {
    const pageProperties = {
      screen_name: 'Cost Guide Page',
      screen_template: ScreenTemplate.COST_GUIDE,
      seo_page_id: 1533,
    };
    if (deviceChar && Object.keys(deviceChar).length > 0) {
      setPagePropertiesFromData(pageProperties);
      setDeviceDataFromHeaders(deviceChar);
    }

    trackAmplitudeEvent(AmplitudeEvent.errorViewed, {
      error_description: 'SEO no results',
    });
  }, [deviceChar]);

  return (
    <>
      <SeoGlobalNavbar enrollmentURL="/app/vhp/get-started" />
      <SlimSearch expanded segmentation={segmentation} searchDefaults={undefined} />
      <Grid container>
        <Grid item xs={12}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            gap={1.25}
            padding={9}
            textAlign="center">
            <IconIllustrationSmallCalculator size={100} />
            <Typography variant="h2" color="textPrimary">
              Cost data for{' '}
              <Typography
                component="span"
                textTransform="capitalize"
                fontSize="inherit"
                fontWeight="inherit">
                {city}
              </Typography>
              , {stateCode?.toUpperCase()} is currently unavailable.
            </Typography>
            <Typography variant="body1" color="textPrimary">
              Try searching again for the nearest city.
            </Typography>
            <Typography variant="body3" color="textSecondary">
              Error Code: 404
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <CoreGlobalFooter />
        </Grid>
      </Grid>
    </>
  );
}
